namespace RecordShield.Workspace {
    export class ProductItems2Form extends Serenity.PrefixedContext {
        static formKey = 'Workspace.ProductItems2';

    }

    export interface ProductItems2Form {
        ProductId: Serenity.LookupEditor;
        Name: Serenity.StringEditor;
        MIMEType: Serenity.StringEditor;
        Length: Serenity.IntegerEditor;
        Size: Serenity.IntegerEditor;
        SortOrder: Serenity.IntegerEditor;
        Extension: Serenity.StringEditor;
        ContentKey: Serenity.IntegerEditor;
        CustomerKey: Serenity.IntegerEditor;
        Sync: Serenity.BooleanEditor;
        SyncDate: Serenity.DateEditor;
        Code: Serenity.IntegerEditor;
        ContentTypeId: Serenity.IntegerEditor;
        EncryptionKeyId: Serenity.IntegerEditor;
        EncryptedName: Serenity.StringEditor;
        EncryptionPath: Serenity.StringEditor;
    }

    [['ProductId', () => Serenity.LookupEditor], ['Name', () => Serenity.StringEditor], ['MIMEType', () => Serenity.StringEditor], ['Length', () => Serenity.IntegerEditor], ['Size', () => Serenity.IntegerEditor], ['SortOrder', () => Serenity.IntegerEditor], ['Extension', () => Serenity.StringEditor], ['ContentKey', () => Serenity.IntegerEditor], ['CustomerKey', () => Serenity.IntegerEditor], ['Sync', () => Serenity.BooleanEditor], ['SyncDate', () => Serenity.DateEditor], ['Code', () => Serenity.IntegerEditor], ['ContentTypeId', () => Serenity.IntegerEditor], ['EncryptionKeyId', () => Serenity.IntegerEditor], ['EncryptedName', () => Serenity.StringEditor], ['EncryptionPath', () => Serenity.StringEditor]].forEach(x => Object.defineProperty(ProductItems2Form.prototype, <string>x[0], { get: function () { return this.w(x[0], (x[1] as any)()); }, enumerable: true, configurable: true }));
}
